import { render, staticRenderFns } from "./copy-fee.vue?vue&type=template&id=862199d0&scoped=true&"
import script from "./copy-fee.vue?vue&type=script&lang=js&"
export * from "./copy-fee.vue?vue&type=script&lang=js&"
import style0 from "./copy-fee.vue?vue&type=style&index=0&id=862199d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862199d0",
  null
  
)

export default component.exports